import { render } from "./Register_1.vue?vue&type=template&id=35f9301e&scoped=true"
import script from "./Register_1.vue?vue&type=script&lang=js"
export * from "./Register_1.vue?vue&type=script&lang=js"

import "./Register_1.vue?vue&type=style&index=0&id=35f9301e&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Nakhoncity\\Nakhoncity-App-Register\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f9301e"]])

export default __exports__